export default "__VITE_PUBLIC_ASSET__fcdf78db__"